'use client';

import { SideNavDrawer } from '@naumu/ui/components/side-nav-drawer';

import { DocsSidebar } from './docs-sidebar';
import type { DocsNavGroup } from '../helpers/docs-loader';

/**
 * DocsNavDrawer - mobile docs nav: the shared left-anchored SideNavDrawer
 * wrapping the docs sidebar. A nav-link tap dismisses it (the shell closes on
 * any body tap).
 */
export const DocsNavDrawer = ({
	navGroups,
	open,
	onClose,
}: {
	navGroups: DocsNavGroup[];
	open: boolean;
	onClose: () => void;
}): React.JSX.Element => (
	<SideNavDrawer
		open={open}
		onClose={onClose}
		title="Documentation navigation"
		label="Documentation"
		className="border-r border-border-weak bg-background"
	>
		<DocsSidebar navGroups={navGroups} />
	</SideNavDrawer>
);
